<i class="far fa-comments" data-fa-symbol="comments"></i>
<i class="far fa-edit" data-fa-symbol="edit"></i>
<i class="fas fa-flag" data-fa-symbol="flag"></i>

<div class="wrapper">
  <div class="table-container" *ngIf="!edit">
    <div #eventList class="m-custom">
      <ul class="list-group list-group-flush list" *qmLoading="loading">
        <li
          *ngFor="let s of events; trackBy: trackById"
          class="list-group-item"
          [ngClass]="{
            flagged: flags.has(s._id)
          }"
          (mouseenter)="preloadComments(s)"
        >
          <div class="color-badge" [ngClass]="'priority-' + s.priority?.id?.class"></div>
          <div class="text-block">
            <div class="small-text" (click)="setActive(s)">
              <div class="name" *ngIf="s.createUser?.email; else noCreateUserEmail">
                <a href="mailto:{{s.createUser.email}}" target="_blank">
                  {{getNameOfUser(s.createUser)}}
                </a>
              </div>
              <ng-template #noCreateUserEmail>
                {{getNameOfUser(s.createUser)}}
              </ng-template>
              <div class="date text-right">
                <span
                  *ngIf="(s.updatedAt | qmDateDiff : s.createdAt : 'm') >= 1"
                  ngbTooltip="{{s.updatedAt | qmDateDistance}}"
                >
                  ({{ 'updated' | translate }}
                  <ng-container *ngIf="isSameDay(s.updatedAt, s.createdAt); else bigUpdateDateDiff">
                    {{s.updatedAt | qmDateFormat:'HH:mm'}})
                  </ng-container>
                  <ng-template #bigUpdateDateDiff>
                    {{s.updatedAt | qmDateFormat:dateFormat}})
                  </ng-template>
                  &nbsp;&nbsp;
                </span>
                <a [href]="getTaskLink(s._id)" target="_blank" ngbTooltip="{{s.createdAt | qmDateDistance}}">
                  {{s.createdAt | qmDateFormat:dateFormat}}
                </a>
              </div>
            </div>
            <div class="content" (click)="setActive(s)">
              <div>
                <p style="margin-bottom: 0;">
                  <span *ngIf="flags.has(s._id)" class="flag-block">
                    <svg class="svg-inline--fa fa-w-20">
                      <use xlink:href="#flag"></use>
                    </svg>
                  </span>
                  {{s.message}}
                </p>
                <!-- extra div is here to ensure the clickable area isn't wider than the button itself -->
                <div class="small-text task-buttons" *qmAuth="'button_write'">
                  <a (click)="editMessage(s)">
                    <svg class="svg-inline--fa fa-w-20">
                      <use xlink:href="#edit"></use>
                    </svg>
                  </a>
                  <a (click)="toggleFlag($event, s._id)" class="flag-button">
                    <svg class="svg-inline--fa fa-w-20">
                      <use xlink:href="#flag"></use>
                    </svg>
                  </a>
                </div>
              </div>
              <div>
                <span
                  class="badge badge-pill"
                  [ngClass]="{
                    'badge-success': s.status === 'completed',
                    'badge-warning': s.status === 'pending',
                    'badge-danger': s.status === 'late'
                  }"
                >
                  {{getItemStatusText(s.status) | translate}}
                </span>
                <div *ngIf="s.messageCount" class="comment-counter">
                  <svg class="svg-inline--fa fa-w-20">
                    <use xlink:href="#comments"></use>
                  </svg>
                  <span class="badge badge-pill badge-info">{{s.messageCount}}</span>
                </div>
              </div>
            </div>
            <div class="small-text" *ngIf="s.subscribers.length > 0">
              <div class="d-flex flex-row subscribers">
                <a
                  *ngFor="let sub of s.subscribers; trackBy: trackById"
                  class="name"
                  style="margin-left: 0.2em;"
                  [ngbTooltip]="sub.name"
                  href="mailto:{{sub.email}}"
                >
                  {{getInitialsOfSubscriber(sub)}}
                </a>
              </div>
            </div>
            <div class="small-text" *ngIf="s.parents && s.parents.length > 0">
              <div class="name">
                <ng-container *ngFor="let location of getTaskLocations(s); let isLast = last; trackBy: trackById">
                  <ng-container *ngIf="location.coordinates; else noCoordinates">
                    <a href="#" (click)="onAddressClick($event, location.coordinates)">{{location.label}}</a>
                  </ng-container>
                  <ng-template #noCoordinates>
                    <a [href]="location.link" target="_blank">{{location.label}}</a>
                  </ng-template>
                  <ng-container *ngIf="!isLast"> / </ng-container>
                </ng-container>
              </div>
            </div>
            <div class="comments" *ngIf="isActive(s)">
              <div
                *ngFor="let s2 of (getCommentsSubject(s) | async); trackBy: trackById"
                class="comment-block"
                [ngClass]="{ placeholder: s2.placeholder }"
              >
                <div class="small-text">
                  <div class="name" *ngIf="s2.user?.email; else noCommentUserEmail">
                    <a href="mailto:{{s2.user.email}}" target="_blank">
                      {{getNameOfUser(s2.user)}}
                    </a>
                  </div>
                  <ng-template #noCommentUserEmail>
                    {{getNameOfUser(s2.user)}}
                  </ng-template>
                  <div ngbTooltip="{{s2.updatedAt | qmDateDistance}}">
                    {{s2.updatedAt | qmDateFormat:dateFormat}}
                  </div>
                </div>
                <div class="comment">
                  {{s2.contentData}}
                </div>
              </div>
            </div>
            <div class="input-block" *ngIf="isActive(s)">
              <div *qmAuth="'button_write'">
                <button type="button" class="btn btn-outline-success" [disabled]="!commentText"
                        (click)="saveComment(s._id, commentText)">
                  {{'Save' | translate}}
                </button>
              </div>
              <div *qmAuth="'button_write'">
                <textarea class="form-control" rows="1" cols="100" style="font-size: 1.2em;"
                        [(ngModel)]="commentText" placeholder="{{'New comment' | translate}}" (keyup.enter)="saveComment(s._id, commentText)"></textarea>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="row" *ngIf="!edit && events.length > 0">
      <div class="pagination" style="margin: auto;">
        <ngb-pagination
          (pageChange)="pageChanged($event)"
          [collectionSize]="pagination.total"
          [pageSize]="pagination.limit"
          [(page)]="pagination.page"
          [maxSize]="10"></ngb-pagination>
        <!--<pagination [(ngModel)]="pagination.page"
                    [maxSize]="10"
                    [itemsPerPage]="pagination.limit"
                    [totalItems]="pagination.total"
                    (pageChanged)="pageChanged($event)"></pagination>-->
      </div>
    </div>
  </div>

</div>
<div class="diary-editor" *ngIf="edit && selectedEdit">
  <qm-vivo-notification [edit]="selectedEdit" (close)="closeEdit()"></qm-vivo-notification>
</div>
